import React from 'react';
export function EditorColorFillIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("path", {
    d: "M14.932 13H9.068l2.625-7h.614l2.625 7z"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 1H1v22h22V1zm-9.307 3h-3.386l-6 16h2.136l1.875-5h7.364l1.875 5h2.136l-6-16z"
  }));
}